import React from 'react';
import clsx from 'clsx';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { useSidebarStyles } from './styles';

const SidebarItem = ({
	section,
	layer,
	active,
	hasActiveChild,
	drawerOpen,
	expandable,
	expanded,
	onClick,
	disabled,
	cLanguage,
	forceL1Indent
}) => {
	const classes = useSidebarStyles();
	const Icon = section.icon;

	const labelClass = layer === 1
		? classes.itemLabelL1
		: layer === 2 ? classes.itemLabelL2 : classes.itemLabelL3;

	const collapsedL1Indent = !drawerOpen && layer === 1 && forceL1Indent;
	const wrapperClass = clsx(
		classes.itemRoot,
		!drawerOpen && classes.itemRootCollapsed,
		collapsedL1Indent && classes.itemRootCollapsedL1Indent,
		!drawerOpen && layer === 2 && classes.itemRootCollapsedL2,
		!drawerOpen && layer === 3 && classes.itemRootCollapsedL3,
		drawerOpen && layer === 2 && classes.itemL2,
		drawerOpen && layer === 3 && classes.itemL3,
		active && classes.itemActive,
		!active && hasActiveChild && classes.itemActiveParent
	);

	const labelText = section.label || '';

	const labelNode = (
		<Typography component="p" className={clsx(labelClass, classes.itemLabel, active && classes.itemLabelActive)}>
			{labelText}
		</Typography>
	);

	const showTooltip = !drawerOpen;

	const listItem = (
		<ListItem
			button
			disabled={disabled}
			onClick={onClick}
			className={wrapperClass}>
			<ListItemIcon className={clsx(classes.itemIcon, !drawerOpen && classes.itemIconCollapsed, (active || hasActiveChild) && classes.itemIconActive)}>
				{Icon ? <Icon /> : null}
			</ListItemIcon>
			{drawerOpen && (
				<ListItemText primary={labelNode} disableTypography />
			)}
			{expandable && drawerOpen && (
				expanded
					? <ExpandLess className={classes.expandIcon} />
					: <ExpandMore className={classes.expandIcon} />
			)}
		</ListItem>
	);

	if (!showTooltip) return listItem;

	return (
		<Tooltip
			title={labelText}
			placement="right"
			enterDelay={500}
			arrow
			classes={{ tooltip: classes.tooltipL1, arrow: classes.tooltipArrow }}>
			{listItem}
		</Tooltip>
	);
};

export default SidebarItem;
